export function parseDataWithEdges(data, keys = []) {
    if (!keys || !data) return data;

    const currentKey = keys.shift();
    if (!(currentKey in data)) return data;

    const items = [];

    const { edges, ...otherData } = data?.[currentKey] ?? {};

    edges?.forEach((edge) => {
        const node = edge?.node;
        if (node) {
            const copiedKeys = [...keys];
            items.push(parseDataWithEdges(node, copiedKeys));
        }
    });

    return { ...otherData, [currentKey]: items };
}
